import {Injectable} from '@angular/core';
import {STATIONS} from './mock-stations';
import {Station} from './station';

@Injectable()
export class StationService {

  getStationByName(label: string): Promise<Station> {
    return Promise.resolve(
      STATIONS.find(
        station => station.label === label
      )
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/station/station.service.ts